import { tenantAtom } from "atoms/tenantAtom.ts";
import { useCurrencies } from "hooks/useCurrencies.ts";
import React from "react";
import { useRecoilValue } from "recoil";
import { CurrencyCode, formatCurrency } from "utils/formatCurrency.ts";

import CommissionData = App.Data.CommissionData;

interface CurrencyCellProps {
    commission: CommissionData;
    fallback?: React.ReactNode;
}

export const PayoutCell: React.FC<CurrencyCellProps> = ({ commission, fallback = "-" }) => {
    const { loading, error, get } = useCurrencies();
    const globalCurrency = useRecoilValue(tenantAtom).currency;

    // Fall back to the tenant's global currency when the offer's own currency isn't resolvable
    // (e.g. not (yet) loaded) — matches WithPayoutFormula's behavior for the same "fix" formula
    // type, instead of silently rendering the fallback "-" for an amount that does exist.
    const currency = get(commission.offer?.currency_id) ?? globalCurrency;

    if (loading || error) {
        return null;
    }

    if (commission.payout_placeholder) {
        return <>{commission.payout_placeholder}</>;
    }

    if (commission.payout_formula && commission.formula_type === "percent") {
        return <>{commission.payout_formula}%</>;
    }

    if (commission.payout_formula && commission.formula_type === "fix" && currency) {
        return <>{formatCurrency(Number(commission.payout_formula), currency.currency_code as CurrencyCode)}</>;
    }

    if (commission.payout_formula && commission.formula_type === "formula") {
        return <>{commission.payout_formula}</>;
    }

    return <>{fallback}</>;
};
